import slaydApi from './axiosInstance';

export interface UserData {
  phoneNumber: string;
  name: string;
  gender: string;
  instagramUsername?: string;
}

export interface User extends UserData {
  id: number;
}

export interface AuthResponse {
  token: string;
  user: User;
}

export interface ValidationResponse {
  valid: boolean;
  user: User;
}

export interface PhoneCheckResponse {
  exists: boolean;
}

export const apiCheckPhone = async (
  phone: string
): Promise<PhoneCheckResponse> => {
  try {
    const response = await slaydApi.post<PhoneCheckResponse>(
      '/account/check_phone/',
      {
        phoneNumber: phone,
      }
    );

    if (!response.data) throw new Error('Invalid response');

    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error('Error checking if phone number exists');
  }
};

export const apiSignIn = async (phone: string): Promise<AuthResponse> => {
  try {
    const response = await slaydApi.post<AuthResponse>('/account/login/', {
      phoneNumber: phone,
    });

    if (!response.data || !response.data.token || !response.data.user)
      throw new Error('Invalid response');

    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error('Sign in failed');
  }
};

export const apiSignUp = async ({
  phoneNumber,
  name,
  gender,
  instagramUsername,
}: {
  phoneNumber: string;
  name: string;
  gender: string;
  instagramUsername?: string;
}): Promise<AuthResponse> => {
  try {
    const response = await slaydApi.post<AuthResponse>('/account/register/', {
      phoneNumber: phoneNumber,
      name: name,
      gender: gender.toUpperCase(),
      instagramUsername: instagramUsername,
    });

    if (!response.data || !response.data.token || !response.data.user)
      throw new Error('Invalid response');

    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error('Sign up failed');
  }
};

export const apiValidateToken = async (
  token: string
): Promise<ValidationResponse> => {
  try {
    const response = await slaydApi.post<ValidationResponse>(
      '/account/validate_token/',
      {
        token,
      }
    );

    if (!response.data || !response.data.valid || !response.data.user)
      throw new Error('Invalid response');

    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error('Token Validation Failed');
  }
};
